
export default function Footer() {
  return (
    <footer className="bg-[#FAFAF8] border-t border-[#eee] font-body">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="flex flex-col items-center gap-6 sm:gap-8">
          <span className="text-xl font-display tracking-[0.1em] text-[#1a1a1a]">YASMINE CREATES</span>

          <div className="flex items-center gap-4">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 flex items-center justify-center rounded-md bg-white border border-[#eee] hover:border-[#F5C518] hover:bg-[#F5C518] text-[#999] hover:text-[#1a1a1a] transition-all cursor-pointer">
              <i className="ri-linkedin-fill text-base"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 flex items-center justify-center rounded-md bg-white border border-[#eee] hover:border-[#F5C518] hover:bg-[#F5C518] text-[#999] hover:text-[#1a1a1a] transition-all cursor-pointer">
              <i className="ri-instagram-line text-base"></i>
            </a>
            <a href="mailto:hello@yasminecreates.com" className="w-10 h-10 flex items-center justify-center rounded-md bg-white border border-[#eee] hover:border-[#F5C518] hover:bg-[#F5C518] text-[#999] hover:text-[#1a1a1a] transition-all cursor-pointer">
              <i className="ri-mail-line text-base"></i>
            </a>
          </div>

          <div className="w-full max-w-xs h-[1px] bg-[#eee]"></div>

          <div className="text-center">
            <p className="text-xs text-[#999] mb-2">
              &copy; 2025 Yasmine Creates. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
